import { connect } from 'react-redux'
import { loginActions, authActions } from '../../actions'
import { Redirect, Link } from 'react-router-dom'
import { color, patterns, pxToRem } from '../../utils'
import AuthErrors from './AuthErrors'
import Box from '../../components/Box'
import Logo from '../../components/Logo'
import Button from '../../components/Form/Button'
import FormControl from '../../components/Form/FormControl'
import InputError from '../../components/Form/InputError'
import { SimpleLoader, Pace } from '../../components/loaders'
import Input from '../../components/Form/Input'
import React, { Component } from 'react'
import styled from 'styled-components'
import Welcome from '../../components/Welcome'

const { REACT_APP_DEFAULT_EMAIL } = process.env

const WrapperLogin = styled.div`
  max-width: ${pxToRem(960)};
  width: 100%;
  margin: auto;
  padding: 0 ${pxToRem(15)};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${pxToRem(15)};
  @media only screen and (max-width: 765px) {
    flex-direction: column;
  }
`

const WrapperLoader = styled.div`
  height: ${pxToRem(400)};
  position: relative;
  width: 100%;
`

const LogoWrapper = styled(Logo)`
  margin: ${pxToRem(30)} ${pxToRem(10)};
  max-width: ${pxToRem(300)};
  ${({ name }) => {
    if (name === 'client') {
      return `margin-bottom: ${pxToRem(40)};`
    }
    if (name === 'exo') {
      return 'margin-top: auto;'
    }
  }};
`

const Title = styled('h1')`
  text-align: center;
  color: ${color.text_color};
  opacity: 0.7;
  font-size: ${pxToRem(29)};
  font-weight: 400;
  margin-bottom: ${pxToRem(15)};
`

const WelcomeTitle = styled('h2')`
  color: ${color.text_color};
`
  
const ContactEmail = styled('a')`
  color: ${color.text_color};
`

const FormActions = styled('div')`
  margin-top: ${pxToRem(45)};
  margin-bottom: ${pxToRem(10)};

  &:after {
    display: block;
    content: '';
    clear: both;
  }
`

const SuccessMessage = styled(Box)`
  background: #e3ffd5;
  color: #466b33;
  margin: 1em 0;
  max-width: 95%;
`

const ErrorMessage = styled(Box)`
  background: #fff2f2;
  color: red;
  margin: 1em 0;
  max-width: 95%;
`

const ContainerForm = styled(Box)`
  position: relative;
  z-index: 2;
  width: ${pxToRem(300)};
  margin-right: ${pxToRem(-90)};
  a {
    float: left;
    color: ${color.secondary};
    line-height: ${pxToRem(35)};
  }

  button {
    float: right;
  }
  @media only screen and (max-width: 765px) {
    margin-right: 0;
    margin-bottom: ${pxToRem(-80)};
  }
`

const ContainerWelcome = styled(Welcome)`
  position: relative;
  z-index: 1;
  flex: 1;
  padding: ${pxToRem(50)};
  padding-left: ${pxToRem(150)};
  p {
    color: ${color.text_color};
  }
  @media only screen and (max-width: 765px) {
    padding: ${pxToRem(80)} ${pxToRem(30)} ${pxToRem(15)};
  }
`

const WrapperBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 100vh;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  * {
    box-sizing: border-box;
  }
`

const WrapperLink = styled(Link)`
  font-size: ${pxToRem(14)};
`

class Login extends Component {
  constructor(props) {
    super(props)

    this.state = {
      user: {
        email: '',
        password: ''
      },
      submitted: false,
      emailError: null,
      passwordError: null
    }
  }

  componentDidMount() {
    this.props.stopFetching()
  }

  handleChange = event => {
    const { clearErrors } = this.props
    const { name, value } = event.target
    const { user } = this.state
    clearErrors()
    this.setState({
      user: {
        ...user,
        [name]: value
      },
      submitted: false,
      emailError: null,
      passwordError: null
    })
  }

  handleSubmit = event => {
    event.preventDefault()

    this.setState({ submitted: true })

    const { user } = this.state

    let emailValid = this.validateEmail()
    let passwordValid = this.validatePassword()

    if (emailValid && passwordValid) {
      this.props.fetchAuthentication(user)
    }
  }

  validateEmail = () => {
    const { user } = this.state

    if (!user.email) {
      this.setState({ emailError: 'E-mail é obrigatório' })
      return false
    } else if (user.email && !patterns.email().test(String(user.email).toLowerCase())) {
      this.setState({ emailError: 'E-mail inválido' })
      return false
    }

    return true
  }

  validatePassword = () => {
    const { user } = this.state

    if (!user.password) {
      this.setState({ passwordError: 'Senha é obrigatória' })
      return false
    }

    return true
  }

  render() {
    const { user, submitted, emailError, passwordError } = this.state

    const {
      auth_error,
      fetching,
      accessToken,
      successMessage,
      errorMessage,
      setSuccessMessage,
      router,
      setFailureMessage
    } = this.props

    if (accessToken) return <Redirect to="/" />

    if (router.location.search.includes('?success_status=password_new')) {
      router.history.push('/entrar')
      setSuccessMessage('Senha cadastrada com sucesso!')
    }

    if (router.location.search.includes('?success_status=password_changed')) {
      router.history.push('/entrar')
      setSuccessMessage('Senha alterada com sucesso!')
    }

    if (router.location.search.includes('?failure_status=invalid_token')) {
      router.history.push('/entrar')
      setFailureMessage('Link expirado, consulte o administrador do sistema')
    }

    return (
      <WrapperBox>
        {!!successMessage && <SuccessMessage>{successMessage}</SuccessMessage>}
        {!!errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}

        <LogoWrapper name="client" with="200" height="100" />
        <WrapperLogin>
          {!!fetching && (
            <Pace>
              <WrapperLoader>
                <SimpleLoader />
              </WrapperLoader>
            </Pace>
          )}
          <ContainerForm>
            <Title>Acesse:</Title>

            <AuthErrors authError={auth_error} fetching={fetching} />

            <form onSubmit={this.handleSubmit}>
              <FormControl>
                <Input
                  name="email"
                  autoFocus={true}
                  label="Email"
                  display="block"
                  value={user.email}
                  onChange={this.handleChange}
                />
                {submitted && emailError && <InputError>{emailError}</InputError>}
              </FormControl>
              <FormControl>
                <Input
                  name="password"
                  label="Senha"
                  type="password"
                  display="block"
                  value={user.password}
                  onChange={this.handleChange}
                />
                {submitted && passwordError && <InputError>{passwordError}</InputError>}
              </FormControl>
              <FormActions>
                <WrapperLink to="/recuperar-senha">Esqueci minha senha</WrapperLink>
                <Button>Entrar</Button>
              </FormActions>
            </form>
          </ContainerForm>

          <ContainerWelcome>
            <WelcomeTitle>
              <strong>Bem Vindo!</strong>
            </WelcomeTitle>

            <p>
              Essa plataforma foi pensada para você colaborador!<br />
              <br />
              Nela você encontrará todas as informações sobre os produtos químicos os quais utiliza
              em seu dia a dia.<br />
              <br />
              É de interesse de todos nós manter a segurança e o bom uso de todos os produtos, por
              isso utilize essa ferramenta sempre que precisar!<br />
              <br />
              Caso ainda não tenha seus dados de acesso, solicite-os através do email:
            </p>

            <ContactEmail href={`mailto:${REACT_APP_DEFAULT_EMAIL}`}>{REACT_APP_DEFAULT_EMAIL}</ContactEmail>

            <p>Muito obrigado!</p>
          </ContainerWelcome>
        </WrapperLogin>
        <LogoWrapper name="exo" />
      </WrapperBox>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  fetchAuthentication: user => {
    return dispatch(loginActions.fetchAuthentication(user))
  },
  clearErrors: () => {
    return dispatch(loginActions.clearErrors())
  },
  setSuccessMessage: message => {
    return dispatch(loginActions.setSuccessMessage(message))
  },
  setFailureMessage: message => {
    return dispatch(loginActions.setFailureMessage(message))
  },
  stopFetching: () => {
    return dispatch(authActions.stopFetching())
  }
})

const mapStateToProps = state => ({
  fetching: state.auth.is_fetching,
  accessToken: state.headers.accessToken,
  auth_error: state.authResponse.error,
  successMessage: state.authResponse.successMessage,
  errorMessage: state.authResponse.errorMessage
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./src/containers/Login/index.js